import { RootState } from 'redux/reducers'

export const selectTranslations = (state: RootState) => state.translations.data
export const selectTranslationsLoading = (state: RootState): boolean => state.translations.loading
export const selectTranslationsError = (state: RootState): boolean => state.translations.error
